export const buildPublicAttendanceRoom = (schoolYearId) => (
  schoolYearId ? `public:attendance:${schoolYearId}` : null
);

export const buildStaffAttendanceRoom = (schoolYearId) => (
  schoolYearId ? `staff:attendance:${schoolYearId}` : null
);

export const buildStaffTicketingRoom = (schoolYearId) => (
  schoolYearId ? `staff:ticketing:${schoolYearId}` : null
);
